import { RouteTag } from '@frontend/sports/common/core/data-access/route';
import { use } from '@frontend/sports/common/core/utils/router';
import { WidgetResolver, WidgetSchemaMarkupResolver } from '@frontend/sports/widget/core/feature';
import { WidgetLayoutComponent } from '@frontend/sports/widget/feature/layout';

import { ESportBreadcrumbsResolver } from '../esports/esports-breadcrumbs.resolver';
import { SitemapRoutingToken } from '../sitemap/sitemap-routing';
import { SportRoute } from './multi-route.model';

export const INTERNAL_ESPORTS_ROUTES: SportRoute[] = [
    {
        path: '',
        component: WidgetLayoutComponent,
        resolve: use(WidgetResolver),
        data: {
            tag: RouteTag.EsportsLobby,
            breadcrumbs: ESportBreadcrumbsResolver,
            schemaMarkup: WidgetSchemaMarkupResolver,
            sitemap: SitemapRoutingToken.EsportsSitemapResolver,
        },
    },
];
